import { ReactNode } from 'react';
import { Typography } from '@mui/material';

export const defaultRenderer = (s: ReactNode) => (
	<Typography variant="b2-m" fontWeight={700} color="secondary.dark">
		{s}
	</Typography>
);
